var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStringToCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 27,
    viewBox: "0 0 45 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    rx: 2,
    fill: "#FFD822"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 10,
    height: 19,
    rx: 2,
    fill: "#FFB922"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.628 14V12.53L10.488 12.208V9.576C10.488 9.10933 10.3433 8.74533 10.054 8.484C9.774 8.22267 9.34 8.092 8.752 8.092C8.35067 8.092 7.954 8.15733 7.562 8.288C7.17933 8.40933 6.85267 8.57733 6.582 8.792L5.798 7.266C6.20867 6.97667 6.70333 6.75267 7.282 6.594C7.86067 6.43533 8.44867 6.356 9.046 6.356C10.194 6.356 11.0853 6.62667 11.72 7.168C12.3547 7.70933 12.672 8.554 12.672 9.702V14H10.628ZM8.332 14.112C7.744 14.112 7.24 14.014 6.82 13.818C6.4 13.6127 6.078 13.3373 5.854 12.992C5.63 12.6467 5.518 12.2593 5.518 11.83C5.518 11.382 5.62533 10.99 5.84 10.654C6.064 10.318 6.414 10.0567 6.89 9.87C7.366 9.674 7.98667 9.576 8.752 9.576H10.754V10.85H8.99C8.47667 10.85 8.122 10.934 7.926 11.102C7.73933 11.27 7.646 11.48 7.646 11.732C7.646 12.012 7.75333 12.236 7.968 12.404C8.192 12.5627 8.49533 12.642 8.878 12.642C9.242 12.642 9.56867 12.558 9.858 12.39C10.1473 12.2127 10.3573 11.956 10.488 11.62L10.824 12.628C10.6653 13.1133 10.376 13.482 9.956 13.734C9.536 13.986 8.99467 14.112 8.332 14.112Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 19,
    height: 19,
    rx: 2,
    fill: "#08E564"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 8,
    width: 10,
    height: 19,
    rx: 2,
    fill: "#1AB00A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5664 11L14.0012 11",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L26.8696 13.5981V8.40192L30 11Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4336 16L29.9988 16",
    stroke: "#FF0000",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L17.1304 13.4019V18.5981L14 16Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringToCalender);
export default __webpack_public_path__ + "static/media/string_to_calender.e02cd96e6a379515581e7848daff08d3.svg";
export { ForwardRef as ReactComponent };